export default "__VITE_ASSET__DjTvTCAn__"